/**
 * @classdesc - ハッシュのカウント数に応じて指アイコンを表示するクラス
 */

import { Container, Sprite } from 'pixi.js';
import { gsap } from 'gsap';


export default class FvGoodItem {

    constructor(app, texture) {
        this.app = app;
        this.texture = texture;
        this.container = new Container();
        this.sprite = null;
        this.originalX = 0;
        this.originalY = 0;
        this._init();
    }


    showAnime(onComplete) {
        const delay = Math.random() * 0.5 + 1.5;

        const randomScale = Math.max(0.7, Math.pow(Math.random() * 1.2, 2));
        this.sprite.scale.x = this.sprite.scale.y = randomScale * 1.5;

        this.container.alpha = 0;

        gsap.to(this.sprite.scale, {x: randomScale, y: randomScale, duration: 0.35, delay: delay, ease: "power2.out"});
        gsap.to(this.container, {
            alpha: 1, duration: 0.1, delay: delay, ease: "power2.out",
            onComplete: onComplete
        });
    }
    

    hide() {
        this._flyAway();
    }


    _init() {
        this._create();
    }

    _create() {
        this.sprite = new Sprite(this.texture);
        this.sprite.anchor.set(0.5);

        const randomScale = Math.max(0.7, Math.pow(Math.random(), 3));
        this.sprite.scale.x = this.sprite.scale.y = randomScale;
        this.container.addChild(this.sprite);

        this.container.pivot.x = this.container.width / 2;
        this.container.pivot.y = this.container.height / 2;

        this._setRandomRotation();
        this._setRandomPosition();

        this.originalX = this.container.x;
        this.originalY = this.container.y;

        this.app.stage.addChild(this.container);
    }

    _setRandomRotation() {
        const randomAngle = Math.random() < 0.5 ? Math.random() * (Math.PI / 2) : Math.random() * (Math.PI / 2) + (3 * Math.PI / 2);
        this.container.rotation = randomAngle;
    }
    
    _setRandomPosition() {
        const minX = 50;
        const maxX = 800;
        const minY = 50;
        const maxY = 1400;
        const avoidXStart = 150;
        const avoidXEnd = 650;
        const avoidYStart = 450;
        const avoidYEnd = 750;

        let x, y;

        do {
            x = Math.random() * (maxX - minX) + minX;
            y = Math.random() * (maxY - minY) + minY;
        } while ((x >= avoidXStart && x <= avoidXEnd) && (y >= avoidYStart && y <= avoidYEnd));

        this.container.x = x;
        this.container.y = y;
    }

    _flyAway() {
        const flyDistance = 1000; 
        const angle = Math.random() * 2 * Math.PI;
        const x = this.container.x + flyDistance * Math.cos(angle);
        const y = this.container.y + flyDistance * 2 * Math.sin(angle);

        const randomScale = Math.max(1.0, Math.pow(Math.random()*1.5, 2));
        const randomRotation = Math.random() * 2 * Math.PI;

        gsap.to(this.container, {
            x: x,
            y: y,
            duration: 1,
            ease: "power2.out",
            onComplete: () => {
                this.app.stage.removeChild(this.container);
            }
        });

        gsap.to(this.sprite.scale, { x: randomScale, y: randomScale, duration: 1, ease: "power2.out" });
        gsap.to(this.container, { rotation: randomRotation, duration: 1, ease: "power2.out" });
    }
}
